// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"f08cfe4f","280":"ffa8a9d4","494":"25a9ec5c"}[chunkId] + ".chunk.js";
};